<template>
    <div class="topbar">
        <img src="../../assets/logo.png" @click="linkTo(6)" class="logo" alt="">
        <div class="logo-another"></div>
        <div class="topbar-signIn">
            <div class="singIN_btn" @click="linkTo(99)">Get started</div>
        </div>
        <rMenu 
        @linkTo='linkTo'
        :active='active'
        type='topBarMenu'
        :linkList="linkList" />
    </div>
</template>

<script>
import rMenu from '@/components/common/r-menu.vue';
export default {
    name:'TopBar',
    components:{
        rMenu
    },
    props:{
        showLogout: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        showMoreFlag:{
            type:Boolean,
            default: () => {
                return true
            }
        }
    },
    data() {
        return {
            active:1,
            linkList : [
                {label:'Home',value:1},
                {label:'How it works',value:2},
                {label:'Benefits',value:3},
                {label:'Charity',value:4},
                {label:'Pricing',value:5},
                {label:'Sign in',value:6}
            ]
        }
    },
    methods: {
        linkTo(key){
            this.active = key
            switch (key) {
                case 1:
                    this.$router.push('/home')
                    break;
                case 2:
                    this.$router.push('/works')
                    break;
                case 3:
                    this.$router.push('/benefits')
                    break;
                case 4:
                    this.$router.push('/monthlyCharity')
                    break;
                case 5:
                    window.location.replace('https://www.beny.com.au')
                    break;
                case 6:
                    window.location.replace('https://web.beny.com.au/#/oa/login')
                    break;
                case 99:
                    window.location.replace('https://web.beny.com.au/#/oa/register')
                    break;
                default:
                    break;
            }
        },
        handleChange(){
            this.$emit('handleCloseChange')
        },
        getPath(){
            const path = this.$route.path;
            switch (path) {
                case '/home':
                    this.active = 1
                    break;
                case '/works':
                    this.active = 2
                    break;
                case '/benefits':
                    this.active = 3
                    break;
                case '/monthlyCharity':
                    this.active = 4
                    break;
                case '/pricing':
                    this.active = 5
                    break;
                case '/login':
                    this.active = 6
                    break;
                default:
                    this.active = -1
                    break;
            }
        }
    },
    mounted() {
        this.getPath()
    },
    watch:{
        $route(to,from){
            this.getPath()
        }
    }
}
</script>

<style lang="scss" scoped>
    .topbar{
        height: 64px;
        background-color: #32312E;
        padding: 0 50px;
        .logo{
            width: 65px;
            height: 31px;
            margin-right:30px;
            float: left;
            margin-top: 16px;
        }
        .logo-another{
            float: left;
            width: 140px;
            height: 64px;
            background-repeat: no-repeat;
            background-size: auto 60px;
            background-position: center center;
            background-image: url('../../assets/yeah.png');
        }
        .topbar-signIn{
            display: flex;
            align-items: center;
            float: right;
            .singIN_btn{
                width: 169px;
                height: 50px;
                background: #F8A4AE;
                opacity: 1;
                border-radius: 4px;
                cursor: pointer;
                text-align: center;
                line-height: 50px;
                font-size: 16px;
                font-weight: bold;
                color: #3A3835;
                margin-top: 7px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/topbar.vue